import { GetInSiteValueDetectionsResult } from './get-in-site-value-detections-result';

export class GetInSiteValueDetectionsResponse {
    status: string;
    message: string;
    result: GetInSiteValueDetectionsResult[];
}
